const ua = window.navigator.userAgent;
const is_smart_phone = (ua.match(/iPhone|Android.+Mobile/));

export default {
    BASE_URL: (process.env.VUE_APP_PATH) || '/',

    //メイン操作部分
    MENU_MODE_DEFAULT: 101, //着せ替えメニュー 商品選択など
    MENU_MODE_CHANGE_ROOM: 102, //部屋画像アップロード
    MENU_MODE_CLIPPING: 103, //切り抜き操作メニュー

    //編集モード
    EDIT_MODE_DEFAULT: 201, //画像張り込みモード
    EDIT_MODE_CLIPPING: 202, //切り抜きモード

    //商品種別 ディレクトリ指定などで値を使う場合があるため文字列
    ITEM_TYPE_CURTAIN: 'curtain', //画像張り込みモード
    ITEM_TYPE_WALL: 'wall', //切り抜きモード
    ITEM_TYPE_FLOOR: 'floor', //切り抜きモード

    //カーテン種別
    CURTAIN_TYPE_DOUBLE: 301, //両開きカーテン
    CURTAIN_TYPE_SINGLE: 302, //片開きカーテン
    CURTAIN_TYPE_PLANE_SHADE: 303, //プレーンシェード
    CURTAIN_TYPE_ROLL_SCREEN: 304, //ロールスクリーン
    CURTAIN_TYPE_LINE_DRAPE: 305, //ラインドレープ

    //切り抜き用ペイントキャンバス設定
    //描画タイプ
    PAINT_FREE_HAND: 1101, //フリーハンド描画
    PAINT_DRAW_LINE: 1102, //直線描画
    PAINT_DRAW_SQUARE: 1103, //矩形描画

    //描画モード
    PAINT_MODE_BRUSH: 1201, //通常描画モード
    PAINT_MODE_ERASER: 1202, //消しゴムモード

    //設定値系
    EDIT_CIRCLE_RADIUS: !is_smart_phone ? 15 : 25, //着せ替え操作部分の●のサイズ
    EDIT_RECT_SIZE: !is_smart_phone ? 500 : 500, //着せ替え操作部分の領域の大きさ

    CANVAS_WIDTH: 1000,
    CANVAS_HEIGHT: 667,

    LOCAL_STORAGE_KEY: 'MyRoomSimulation_save_data', //編集データ保存用localStorageキー名
    LOCAL_STORAGE_IMG_KEY: 'MyRoomSimulation_image_data', //編集データ保存用localStorageキー名
}
